export default __webpack_public_path__ + "static/media/romarin.d68ebee9.jpg";